module.exports = __webpack_public_path__ + "img/media-hi@2x.e821107e.png";